export const DEFAULT_LOCALE = 'es-CL';
export const EQUITY_FORMAT = '1.';
export const DATE_FORMAT = 'dd/MM/yyyy';
